<template>
  <div class="home">

    <gnetHeader v-if="showheader"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    >
    </gnetTabBar>

    <gnetRecordHeader
      v-bind:object="'account'"
      v-bind:title="'Generazione Report'"
      
      v-bind:fields="[]"
      v-bind:actions="headlineActions"
      v-on:click="actionClick($event)"
    />

    <gnetTabs v-bind:tabs="$store.state.campagne" v-on:change="changeCampagnaFatture($event)" v-bind:multi="true" v-bind:multidefault="filtrocampagneF">
      <template v-slot:main>
        <fatture v-if="showtabella" v-bind:campagne="filtrocampagneF"></fatture>
        <pdfmake v-if="showpdf" v-bind:campagne="filtrocampagneF" v-bind:nascondilinee="showpdfnolinee" v-on:change="showpdf=false"></pdfmake>
      </template>
    </gnetTabs>

  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
// import apiclient from '@/apiclient.js'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import fatture from '../components/fatture.vue'
import pdfmake from '../components/fatturepdf.vue'
import gnetMixLib from '@/mixin.js'
import gnetTabs from '../components/tabs.vue'
import gnetRecordHeader from '../components/recordheader.vue'

export default {
  name: 'Home',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetTabs,
    gnetRecordHeader,
    fatture,
    pdfmake,
  },
  data: function() {
    return {
        showpdf: false,
        showpdfnolinee: false,
        showtabella: false,
        showheader: true,
        filtrocampagneF:[false,false,false,false,false,false,true,false, true,false],
        headlineActions: [ {title: 'Scarica PDF no linee', name:'pdfnolinee', symbol:''}, {title: 'Scarica PDF', name:'pdf', symbol:''}, {title:'Visualizza in Tabella', name:'tabella', symbol:''},  ],
    };
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
    actionClick: function(e) {
      console.log(e);
      switch (e) {
        case 'tabella':
          this.showtabella=true;
          this.showpdf=false;
        break;
        case 'pdf':
          this.showtabella=false;
          this.showpdf=true;
          this.showpdfnolinee=false;
        break;
        case 'pdfnolinee':
          this.showtabella=false;
          this.showpdf=true;
          this.showpdfnolinee=true;
        break;
      }    
    },
    changeCampagnaFatture: function(index) {
      console.log('changeCampagnaFatture');
      console.log(index);
      this.showtabella=false;
      this.showpdf=false;
      this.filtrocampagneF[index]=!this.filtrocampagneF[index];
    },

  }
}
</script>
<style scoped>
</style>

